"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconVideoOff = function IconVideoOff(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconVideoOff', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    d: "M.195.195c.26-.26.683-.26.943 0l14.667 14.667a.667.667 0 0 1-.943.943l-3.688-3.689a2 2 0 0 1-1.84 1.217H2a2 2 0 0 1-2-2V4.667a2 2 0 0 1 1.741-1.984L.195 1.138a.667.667 0 0 1 0-.943zM3.056 4L2 4a.667.667 0 0 0-.667.667v6.666c0 .369.299.667.667.667h7.333a.667.667 0 0 0 .667-.667v-.39L3.056 3.999zm6.277-1.332a2 2 0 0 1 2 2v1.95l.07.07 3.54-2.56a.667.667 0 0 1 1.057.54v6.666a.667.667 0 1 1-1.333 0V5.972L11.724 8.1a.667.667 0 0 1-.862-.069l-.667-.666A.667.667 0 0 1 10 6.893V4.667A.667.667 0 0 0 9.333 4H7.107a.667.667 0 1 1 0-1.333z"
  }));
};

var _default = IconVideoOff;
exports.default = _default;